import { render, staticRenderFns } from "./storeinfos.vue?vue&type=template&id=45e399b7&scoped=true&"
import script from "./storeinfos.vue?vue&type=script&lang=js&"
export * from "./storeinfos.vue?vue&type=script&lang=js&"
import style0 from "./storeinfos.vue?vue&type=style&index=0&id=45e399b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e399b7",
  null
  
)

export default component.exports